// Typed client for /api/analytics (see packages/shared/src/features/analytics.ts).

import type { ID } from "@ml/shared";
import type { AnalyticsOverview, AnalyticsRange, BestTimes, PostInsightsRes } from "@ml/shared/features/analytics";
import type { ImpactReport, ImpactSettings } from "@ml/shared/features/impact";
import { api } from "../../lib/api";

export const analyticsKeys = {
  all: ["analytics"] as const,
  overview: (igAccountId: ID, range: AnalyticsRange) => ["analytics", "overview", igAccountId, range] as const,
  bestTimes: (igAccountId: ID) => ["analytics", "best-times", igAccountId] as const,
  postInsights: (igAccountId: ID, mediaId: string) => ["analytics", "post-insights", igAccountId, mediaId] as const,
  /** null = all of the user's accounts. */
  impact: (igAccountId: ID | null) => ["analytics", "impact", igAccountId ?? "all"] as const,
  impactAll: ["analytics", "impact"] as const,
};

export const analyticsApi = {
  overview: (igAccountId: ID, range: AnalyticsRange) => api<AnalyticsOverview>("/api/analytics/overview", { query: { igAccountId, range } }),
  bestTimes: (igAccountId: ID) => api<BestTimes>("/api/analytics/best-times", { query: { igAccountId } }),
  postInsights: (igAccountId: ID, mediaId: string) => api<PostInsightsRes>("/api/analytics/post-insights", { query: { igAccountId, mediaId } }),
  impact: (igAccountId: ID | null) => api<ImpactReport>("/api/analytics/impact", { query: igAccountId ? { igAccountId } : {} }),
  setHourlyRate: (hourlyRate: number) => api<ImpactSettings>("/api/analytics/impact/rate", { method: "PUT", body: { hourlyRate } }),
};
